import { render, staticRenderFns } from "./o-list-practices-v2.vue?vue&type=template&id=2e173c95&scoped=true"
import script from "./o-list-practices-v2.vue?vue&type=script&lang=js"
export * from "./o-list-practices-v2.vue?vue&type=script&lang=js"
import style0 from "./o-list-practices-v2.vue?vue&type=style&index=0&id=2e173c95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e173c95",
  null
  
)

export default component.exports